window.addEventListener('load', function () {

  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true });

  var root    = document.querySelector('.lhf-root');
  var trigger = document.querySelector('.gsap-intro-trigger');
  var logoBox = document.querySelector('.gsap-big-logo-box');
  var hero    = document.querySelector('.lhf-hero');
  var cue     = document.querySelector('.gsap-scroll-cue');

  if (!trigger || !root || !hero) return;

  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: trigger,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.3,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        root.classList.toggle('intro-done', self.progress > 0.55);
      }
    }
  });

  tl.to(logoBox, { scale: 10, opacity: 0, duration: 1 }, 0)
    .to(hero,    { opacity: 1, duration: 0.6 }, 0.4)
    .to({},      { duration: 0.6 });

  if (cue) tl.to(cue, { opacity: 0, duration: 0.15 }, 0);
});